import { AbstractApp } from "./AbstractApp.js";
import { AppEventSupport } from "./AppEventSupport.js";
export class EventSupportingApp extends AbstractApp {
    constructor(platform, icon, themeColor, supportedLanguages, supportsLocationCode = false) {
        super(platform, icon, themeColor, supportedLanguages);
        this.supportsLocationCode = supportsLocationCode;
        this.eventSupport = new AppEventSupport();
    }
    canAutoDeactivate() {
        return this.eventSupport.canAutoDeactivate();
    }
    updateLocationCode(locationCode) {
        return this.eventSupport.updateLocationCode(locationCode);
    }
    get displaysLocationCode() {
        return this.eventSupport.displaysLocationCode;
    }
    activate(item) {
        return this.eventSupport.activate(item);
    }
    deactivate() {
        return this.eventSupport.deactivate();
    }
    idle() {
        return this.eventSupport.idle();
    }
    barcodeScanned(barcode) {
        console.log("EventSupportingApp.barcodeScanned", barcode);
        return this.eventSupport.barcodeScanned(barcode);
    }
    accessCodeEntered(code) {
        console.log("EventSupportingApp.accessCodeEntered", code);
        return this.eventSupport.accessCodeEntered(code);
    }
    admissionCodeReceived(code) {
        console.log('EventSupportingApp.admissionCodeReceived', code);
        return this.eventSupport.admissionCodeReceived(code);
    }
}
//# sourceMappingURL=EventSupportingApp.js.map